<template>
  <el-dialog v-dialogDrag width="600px" title="资源" top="50px" :visible.sync="allModuleProp.editVisible" :close-on-click-modal="false" @close="closeEditModule">
    <el-form ref="editModule" class="dialog-form" label-width="100px" :rules="allModuleProp.rules" :model="moduleForm" size="small">
      <el-form-item label="名 称" prop="permissionName">
        <el-input ref="permissionName" v-model="moduleForm.permissionName" maxlength="20" show-word-limit size="small" />
      </el-form-item>
      <el-form-item label="父 级" prop="pid">
        <el-cascader v-model="moduleForm.pid" class="width-220" :props="selectPidProp" :options="moduleSelectTree" size="small" />
      </el-form-item>

      <el-form-item label="类 型" prop="resourceType">
        <el-select v-model="moduleForm.resourceType" class="width-220" size="small">
          <el-option v-for="{ id, cnName } in dict.moduleType" :key="id" :value="id" :label="cnName" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="moduleForm.resourceType == 2" label="页面来源" prop="pagePid">
        <el-cascader v-model="moduleForm.pagePid" class="width-220" :props="selectPidProp" :options="moduleSelectTree" size="small" />
      </el-form-item>
      <el-form-item v-if="moduleForm.resourceType != 1" label="请求地址">
        <el-input v-model="moduleForm.location" maxlength="100" show-word-limit></el-input>
      </el-form-item>
      <el-form-item v-if="moduleForm.resourceType == 0" label="图 标">
        <el-input v-model="moduleForm.iconPath" maxlength="20" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="动态路由">
        <el-switch v-model="moduleForm.dynamicRouter"> </el-switch>
      </el-form-item>
      <el-form-item v-show="moduleForm.dynamicRouter" label="使用模板">
        <el-switch :value="useTemplate" @change="handleUseTemplateClick"> </el-switch>
      </el-form-item>
      <el-form-item prop="permissionKey" label="权限标识">
        <el-input v-if="!moduleForm.dynamicRouter" v-model="moduleForm.permissionKey" maxlength="100" show-word-limit></el-input>
        <el-select v-else-if="moduleForm.dynamicRouter && moduleForm.useTemplate" :value="dynamicRouterPermissionKey" @change="handleClick">
          <el-option v-for="{ id, cnName } in templateList" :key="id" :value="id" :label="cnName">
            <template>
              <span>{{ cnName }}</span>
              <el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
                <el-button type="text"> <i class="el-tooltip el-icon-question" style="color: #000"></i> </el-button>
                <template slot="content">
                  <span>生成类似这种效果的模板 <i class="el-icon-notebook-2" style="color: #fff"></i>， 左侧为子路由组成的列表，右侧为子路由展示区域</span>
                </template>
              </el-tooltip>
            </template>
          </el-option>
        </el-select>
        <el-tree-select v-else ref="treeSelect" :value="dynamicRouterPermissionKey" :options="treeMetaData" :props="taskTypeTreeProps" @getValue="handleClick" />
        <div>
          <el-button v-if="moduleForm.dynamicRouter && !moduleForm.useTemplate && lowCodeSourcePath" type="text" title="点击跳转到编辑页面" @click="jumpLowCode">{{
            lowCodeSourcePath
          }}</el-button>
        </div>
      </el-form-item>
      <el-form-item label="序号">
        <el-input-number v-model="moduleForm.sortNum" :min="0" :step="1" class="width-220" step-strictly />
      </el-form-item>
      <el-form-item label="资源状态">
        <el-select v-model="moduleForm.isUse" size="small" class="width-220">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="备 注">
        <el-input v-model="moduleForm.remark" :rows="5" type="textarea" maxlength="200" resize="none" placeholder="请输入备注,最多200字" />
      </el-form-item>
      <el-form-item label="分 组">
        <el-select v-model="moduleForm.appCode" placeholder="请选择" :disabled="moduleForm.addApp === 0">
          <el-option v-for="(item, index) in groupList" :key="index" :label="item.appName" :value.sync="item.appCode"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="激活图标">
        <el-upload
          :action="action"
          :headers="headers"
          :show-file-list="true"
          :accept="accept"
          list-type="picture-card"
          :before-upload="beforeUpload"
          :http-request="(e) => uploadIconHandler(e, activeIconKey)"
          :on-success="(response, file, fileList) => iconUploadSuccess(response, file, fileList, activeIconKey)"
          :on-exceed="onExceed"
          :file-list="activeIconList"
          :auto-upload="true"
          :limit="1"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="未激活图标">
        <el-upload
          :action="action"
          :headers="headers"
          :show-file-list="true"
          :accept="accept"
          list-type="picture-card"
          :before-upload="beforeUpload"
          :http-request="(e) => uploadIconHandler(e, inActiveIconKey)"
          :on-success="(response, file, fileList) => iconUploadSuccess(response, file, fileList, inActiveIconKey)"
          :on-exceed="onExceed"
          :file-list="inactiveIconList"
          :auto-upload="true"
          :limit="1"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button size="small" @click="closeEditModule()"> 关闭 </el-button>
      <el-button v-if="allModuleProp.editType === 0" type="primary" size="small" @click="submitEditModuleHandler()"> 新建 </el-button>
      <el-button v-if="allModuleProp.editType === 2" type="primary" size="small" @click="submitEditModuleHandler()"> 更新 </el-button>
    </template>
  </el-dialog>
</template>

<script>
import resources from "@/CommonDP/service/admin/resources-service";
import metadataService from "@/CommonDP/service/metadata-service.js";
import elTreeSelect from "@/CommonDP/components/treeSelect";
import { getToken, uploadDataUrl, removeSuffixes } from "@/CommonDP/utils";
import { browserFileToBase64 } from "@/CommonDP/utils/browserFile";
import treeUtils from "@/CommonDP/utils/treeUtils";
export default {
  components: { elTreeSelect },
  props: {
    moduleForm: {
      type: Object,
      default() {
        return {};
      }
    },
    allModuleProp: {
      type: Object,
      default() {
        return {};
      }
    },
    moduleSelectTree: {
      type: Array,
      default() {
        return [];
      }
    },
    groupList: {
      type: Array,
      default() {
        return [];
      }
    },
    treeMetaData: {
      type: Array,
      default() {
        return [];
      }
    },
    currentRow: {
      type: [Object, null],
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      pathArr: [],
      action: "",
      headers: {
        Authorization: "Bearer " + getToken()
      },
      activeIconKey: "activeIconBase64",
      inActiveIconKey: "inactiveIconBase64",
      accept: "image/png",
      iconSize: 1024 * 2,
      options: [
        { value: "0", label: "启用" },
        { value: "1", label: "禁用" }
      ],
      templateList: [
        {
          id: "1",
          cnName: "模板1",
          desc: ""
        }
      ],
      selectPidProp: {
        emitPath: false,
        checkStrictly: true,
        children: "childList",
        value: "permissionId",
        label: "permissionName"
      },
      taskTypeTreeProps: {
        value: "formCode", // 唯一标识
        children: "children",
        label: "groupName"
      },
      dict: {
        moduleType: [
          {
            id: 0,
            cnName: "菜单"
          },
          {
            id: 1,
            cnName: "按钮"
          },
          {
            id: 2,
            cnName: "页面"
          }
        ]
      }
    };
  },
  computed: {
    useTemplate() {
      return Boolean(this.moduleForm.useTemplate || 0);
    },
    dynamicRouterPermissionKey() {
      let relateId = this.moduleForm.permissionKey;
      relateId = removeSuffixes(relateId);
      return relateId;
    },
    curRowPermissionKey() {
      let relateId = this.currentRow?.permissionKey;
      if (relateId) {
        relateId = removeSuffixes(relateId);
        return relateId;
      }
      return null;
    },
    lowCodeSourcePath() {
      return this.pathArr?.map((item) => item.groupName).join("/");
    },
    activeIconList() {
      if (!this.moduleForm.activeIconBase64) {
        return [];
      }
      return [{ name: "active", url: this.getActiveIconUrl() }];
    },
    inactiveIconList() {
      if (!this.moduleForm.inactiveIconBase64) {
        return [];
      }
      return [{ name: "inactive", url: this.getInactiveIconUrl() }];
    }
  },

  mounted() {
    this.action = uploadDataUrl();
  },
  methods: {
    handleUseTemplateClick(val) {
      this.moduleForm.useTemplate = val ? 1 : 0;
    },
    async handleClick(data, node) {
      this.pathArr = [];
      if (this.moduleForm.useTemplate) return;
      while (node) {
        this.pathArr.unshift(node.data);
        if (node.level > 1) {
          node = node.parent;
        } else {
          node = null;
        }
      }
      if (!data) {
        if (this.$refs.treeSelect) this.$refs.treeSelect.valueTitle = "";
        this.moduleForm.permissionKey = "";
        return;
      }
      if (data === this.dynamicRouterPermissionKey) {
        return;
      } else if (data === this.curRowPermissionKey && this.allModuleProp.editType === 2) {
        this.moduleForm.permissionKey = this.currentRow.permissionKey;
      } else {
        const row = this.pathArr.at(-1);
        const res = await metadataService.queryExistsSysPermission(row.formCode);
        this.moduleForm.permissionKey = res.data ? `${data}__${Math.floor(Math.random() * 9000) + 1000}` : data;
      }
      console.log(data, this.moduleForm.permissionKey);
    },
    jumpLowCode() {
      if (!this.lowCodeSourcePath) {
        return;
      }
      const routeUrl = this.$router.resolve({
        name: "meta-data",
        query: {
          type: this.getType(),
          id: this.pathArr.map((item) => item.groupId).join(",")
        }
      });
      window.open(routeUrl.href, "_blank");
    },
    getType() {
      const data = this.pathArr.at(-1);
      switch (data.templateType) {
        case 3:
          return "table";
        case 2:
          return "form";
        default:
          return "table";
      }
    },
    beforeUpload(file) {
      console.log("before");
      if (file.size > 1024 * 2) {
        this.$warn("图标大小不能超过 2KB");
        return false;
      }
      return true;
    },
    uploadIconHandler(e, key) {
      browserFileToBase64(e.file).then((res) => {
        this.moduleForm[key] = res;
      });
    },
    iconUploadSuccess(response, file, fileList, key) {
      this.moduleForm[key] = response.data.fileKey;
    },
    getActiveIconUrl() {
      if (this.moduleForm.activeIconBase64) {
        return this.moduleForm.activeIconBase64;
      }
      return resources.getResourceActiveIconUrl(this.moduleForm.permissionId);
    },
    getInactiveIconUrl() {
      if (this.moduleForm.inactiveIconBase64) {
        return this.moduleForm.inactiveIconBase64;
      }
      return resources.getResourceInActiveIconUrl(this.moduleForm.permissionId);
    },
    onExceed(f) {
      this.$warn("只能上传一个图标 2KB");
    },
    closeEditModule() {
      this.$emit("closeEditModule");
      this.pathArr = [];
      this.clearValidate();
    },
    setPathArr(type) {
      if (type === 2 && this.moduleForm.dynamicRouter && this.dynamicRouterPermissionKey) {
        console.log(this.dynamicRouterPermissionKey);
        this.pathArr = treeUtils.findPathInTree(this.treeMetaData, "formCode", "children", this.dynamicRouterPermissionKey) || [];
        console.log(this.pathArr);
      }
    },
    submitEditModuleHandler() {
      this.$emit("submitEditModuleHandler");
    },
    async clearValidate() {
      this.$refs.editModule.clearValidate();
    },
    async validate() {
      await this.$refs.editModule.validate();
    },
    permissionNameFocus() {
      this.$refs.permissionName.focus();
    }
  }
};
</script>

<style lang="less" scoped>
::v-deep .dialog-form {
  height: 70vh;
  padding-right: 12px;
  overflow: auto;
  .el-form-item {
    margin-bottom: 12px;
  }
  .el-form-item__error {
    padding-top: 0 !important;
  }
}
.width-220 {
  width: 100%;
}
</style>
